import { useTranslation } from "react-i18next";
import LightCard from "../../../../../../../../components/card/LightCard"
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";


const Rates = ({dataSet}) => {
    const {t} = useTranslation()
    if (!dataSet || Object.keys(dataSet).length === 0) {
        return <p>Keine Daten verfügbar</p>;
    }

    const getRateTitle = (key) => {
        const titles = {
            clientKzm: t("rates.konzertmeister"),
            clientMus: t("rates.musician"),
            estroKzm: t("rates.konzertmeister"),
            estroMus: t("rates.musician"),
        };
        return titles[key];
    };

    const getTypeTitle = (type) => {
        const typeTitles = {
            concerts: t("events.concert"),
            raccords: t("events.raccords"),
            rehearsals: t("events.rehearsals"),
        };
        return typeTitles[type];
    };

    const formatNumber = (num) => {
        return parseFloat(num).toFixed(2);
    };

    const typeOrder = ["rehearsals", "raccords", "concerts"];

    const renderRates = (rates, title) => (
        <>
            <RedHeader title={title} />

            <div className="row px-2">                        
                {Object.keys(rates).map((rateKey) => (
                    <div className="col-xxl-6" key={rateKey}>
                        <u>{getRateTitle(rateKey)}</u>
                        
                        {typeOrder.map((type) => (
                            rates[rateKey][type] !== undefined && (
                                <div key={"costs_"+rateKey+type} className="d-flex flex-row align-items-center my-2" style={{maxWidth:'250px'}}>
                                    <div style={{width:'60%'}}>
                                        {getTypeTitle(type)}
                                    </div>
                                    <div style={{width:'40%', textAlign:'right'}} className="ms-2">
                                        {formatNumber(rates[rateKey][type])} €
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                ))}
            </div>
        </>
    );

    return (<>
            <LightCard>
                <div className='row px-2'>
                    <div className="col-md-6">
                        {renderRates(dataSet.clientRates, t("rates.clients"))}
                    </div>
                    <div className="col-md-6">
                        {renderRates(dataSet.estroRates, t("rates.estros"))}
                    </div>
                </div>
            </LightCard>
    </>)
}

export default Rates

